/* eslint no-underscore-dangle: ["error", { "allow": ["_links", "_items", "_id"] }] */
import queryString from 'query-string';
import {
  SERVICE_REQUEST_STATUS_UPDATE,
  SERVICE_REQUEST_ASSIGNED,
  API_LOADED_SERVICE_CONFIGS,
  REQUEST_ADD_COMMENT,
} from '../types';
import affiliateActions from './affiliates';
import crud from './crud';
import settings from '../../config/settings';

const retrieveServiceConfigs = (page, noLoader) => (dispatch, getState) => {
  const { session: { affiliateId } } = getState();
  const action = crud.apiRead({
    type: 'serviceConfigs',
    urlParams: {
      affiliateId,
      page,
    },
    noLoader,
  });

  return dispatch(action).then((results) => {
    let pageAction;

    if (results._links.next && results._links.next.href !== null && settings.enable_all_data_fetch === true) {
      const params = queryString.parse(results._links.next.href.split('?')[1]);
      pageAction = retrieveServiceConfigs(params.page || null, noLoader);
    } else {
      pageAction = {
        type: API_LOADED_SERVICE_CONFIGS,
        payload: {},
      };
    }

    return dispatch(pageAction);
  });
};


const retrieveMenusRestaurants = page => (dispatch, getState) => {
  const { session: { affiliateId } } = getState();

  const action = crud.apiRead({
    type: 'menusRestaurants',
    urlParams: {
      affiliateId,
      page,
    },
  });

  return dispatch(action);
};

const retrieveRequestById = _id => dispatch => dispatch(crud.apiRead({ type: 'serviceRequest', urlParams: { _id } }));

const retrieveServiceData = dispatch => Promise.all([
  dispatch(retrieveServiceConfigs()),
  dispatch(retrieveMenusRestaurants()),
]);

const processRequestDetail = _id => (dispatch, getState) => dispatch(retrieveRequestById(_id))
  .then((request) => {
    const {
      affiliateId,
    } = getState().session;
    let returnPromise;

    if (affiliateId.replace(/-/gi, '') !== request.affiliate_id) {
      // TODO: update selected affiliate id and reload page
      returnPromise = dispatch(affiliateActions.changeAffiliate(request.affiliate_id))
        .then(() => dispatch(retrieveRequestById(request._id)))
        .then(() => retrieveServiceData(dispatch));
    } else {
      returnPromise = retrieveServiceData(dispatch);
    }

    return returnPromise;
  });

const updateRequest = function updateRequest(id, payload) {
  return function updateRequestFunction(dispatch, getState) {
    const {
      session: {
        user,
      },
    } = getState();

    if (payload.status) {
      dispatch({
        type: SERVICE_REQUEST_STATUS_UPDATE,
        payload: Object.assign({}, payload, {
          id,
          status: payload.status,
        }),
      });
    }

    if (payload.assigned) {
      dispatch({
        type: SERVICE_REQUEST_ASSIGNED,
        payload: Object.assign({}, payload, {
          assignee_name: payload.assignee_name,
        }),
      });
    }

    const data = Object.assign({}, payload, {
      acting_user_full_name: `${user.attributes.first_name} ${user.attributes.last_name}`,
      acting_user: user.id.replace(/-/g, ''),
    });

    return dispatch(crud.apiUpdate({
      type: 'serviceRequest',
      urlParams: {
        _id: id,
      },
      data,
    }));
  };
};

const createRequestComment = function createRequestComment(requestId, commentData) {
  return function createRequestCommentFunction(dispatch, getState) {
    const {
      session: {
        user,
        affiliate: selectedAffiliateInfo,
      },
    } = getState();
    const data = Object.assign({}, commentData);
    const config = {
      type: 'serviceComments',
      data: Object.assign({}, data, {
        acting_user_full_name: `${user.attributes.first_name} ${user.attributes.last_name}`,
        acting_user: user.id.replace(/-/g, ''),
        service_id: requestId,
        affiliate_id: selectedAffiliateInfo.id.replace(/-/g, ''),
        created_by: {
          id: user.id,
          full_name: `${user.attributes.first_name} ${user.attributes.last_name}`,
        },
        source: 'gems-ui',
      }),
    };
    dispatch(crud.apiCreate(config))
      .then(() => {
        dispatch({
          type: REQUEST_ADD_COMMENT,
          payload: {
            id: requestId,
          },
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };
};

const retrieveRequestComments = function retrieveRequestComments(requestId, page) {
  return function retrieveRequestCommentsFunction(dispatch) {
    dispatch(crud.apiRead({
      type: 'requestComments',
      urlParams: {
        requestId,
        page,
      },
    }))
      .then((results) => {
        if (results._links.next && results._links.next.href !== null && settings.enable_all_data_fetch === true) {
          const params = queryString.parse(results._links.next.href.split('?')[1]);
          dispatch(retrieveRequestComments(params.page || null));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
};

export default {
  processRequestDetail,
  updateRequest,
  retrieveMenusRestaurants,
  retrieveRequestComments,
  createRequestComment,
};



// WEBPACK FOOTER //
// ./src/state/actions/requests.js